const calculateOffsetDistance = (withArrow, arrowHeight, tooltipOffset, offsetDistance = 0) => {
  if (withArrow) {
    return arrowHeight + (tooltipOffset - arrowHeight) + offsetDistance;
  }
  return offsetDistance;
};

export { calculateOffsetDistance as c };
//# sourceMappingURL=calculateOffsetDistance-BJpsMB9I.js.map
